import React from 'react';
import {useNavigate} from 'react-router-dom';
import ReviewQuote from '../../components/Reviews/ReviewQuote';
import {reviews} from '../../content/reviews/reviews';
import './Reviews.css';

function Reviews() {
  const navigate = useNavigate();

  // ✅ Control homepage mess here:
  // show only featured reviews first, and cap them.
const featured = reviews.filter((r) => r.featured);
const homepageItems = (featured.length ? featured : reviews).slice(0, 6);

  return (
    <div className='reviews pb-3'>
      <div className='row m-auto align-items-center reviewsection'>
        {homepageItems.map((r) => (
          <div
            key={r.id}
            className='col-12 col-md-6 col-lg-4 mt-4'>
            <ReviewQuote
              text={r.text}
              source={r.source}
            />
          </div>
        ))}
      </div>

      <p className='mt-2 mb-0'>
        <button
          onClick={() => navigate('/reviews')}
          className='btnLightDark px-3 py-1 reviewLink'>
          find more reviews here
        </button>
      </p>
    </div>
  );
}

export default Reviews;
